export const valueFactorRange = ["5Y", "10Y", "15Y"] as const;
export type ValueFactorRange = (typeof valueFactorRange)[number];
